var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WakuMessage } from 'js-waku';
export const buildContentTopic = (name) => `/xmtp/0/${name}/proto`;
export const buildDirectMessageTopic = (sender, recipient) => {
    const members = [sender, recipient];
    members.sort();
    return buildContentTopic(`dm-${members.join('-')}`);
};
export const buildUserContactTopic = (walletAddr) => {
    return buildContentTopic(`contact-${walletAddr}`);
};
export const buildUserIntroTopic = (walletAddr) => {
    return buildContentTopic(`intro-${walletAddr}`);
};
export const buildUserPrivateStoreTopic = (walletAddr) => {
    return buildContentTopic(`privatestore-${walletAddr}`);
};
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const promiseWithTimeout = (timeoutMs, promise, failureMessage) => {
    let timeoutHandle;
    const timeoutPromise = new Promise((_resolve, reject) => {
        timeoutHandle = setTimeout(() => reject(new Error(failureMessage)), timeoutMs);
    });
    return Promise.race([promise(), timeoutPromise]).then((result) => {
        clearTimeout(timeoutHandle);
        return result;
    });
};
export function publishUserContact(waku, keys, address) {
    return __awaiter(this, void 0, void 0, function* () {
        yield waku.lightPush.push(yield WakuMessage.fromBytes(keys.toBytes(), buildUserContactTopic(address)));
    });
}
//# sourceMappingURL=utils.js.map